import AirFilterWidget from '@/comp/common/icons/AirFilterWidget';
import AirTemperatureIcon from '@/comp/common/icons/AirTemperatureIcon';
import DewPointIcon from '@/comp/common/icons/DewPointIcon';
import FlowIcon from '@/comp/common/icons/FlowIcon';
import PressureIcon from '@/comp/common/icons/PressureIcon';
import ValveWidget from '@/comp/common/icons/ValveWidget';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { MenuProps } from 'antd';
import { GlobalToken } from 'antd/es/theme/interface';
import { CombinationIconWrapper } from '@/comp/common/icons/CombinationIconWrapper';
import { IconWrapper } from '@/comp/common/icons/IconWrapper';
import StationStore from '@/store/Station/StationStore';

export const getMenuItems = (
  token: GlobalToken,
  t: (key: string) => string,
  stationStore: StationStore,
): MenuProps['items'] => {
  const filterMenu = {
    key: 'filter',
    label: t('Filter'),
    children: [
      {
        key: DeviceType.AirFilter,
        label: t('Air Filter'),
        icon: <AirFilterWidget borderColor={token.colorIcon} backgroundColor="transparent" width={16} height={16} />,
      },
    ],
  };
  const connectorMenu = {
    label: t('Connector'),
    key: DeviceType.Connector,
    // icon: <ControlConnectedIcon height={16} width={16} />,
  };


  if (stationStore.stationTier < 3) {
    return [
      {
        key: 'title',
        label: t('Add on pipe'),
        disabled: true,
      },
      {
        type: 'divider',
      },
      filterMenu,
      connectorMenu,
    ];
  }

  return [
    {
      key: 'title',
      label: t('Add on pipe'),
      disabled: true,
    },
    {
      type: 'divider',
    },
    {
      key: 'sensor',
      label: t('Sensor'),
      children: [
        {
          key: DeviceType.FlowSensor,
          label: t('Flow'),
          icon: (
            <IconWrapper>
              <FlowIcon color={token.colorIcon} />
            </IconWrapper>
          ),
        },
        {
          key: DeviceType.PressureSensor,
          label: t('Pressure'),
          icon: (
            <IconWrapper>
              <PressureIcon fillColor={token.colorIcon} />
            </IconWrapper>
          ),
        },
        {
          key: DeviceType.DewpointSensor,
          label: t('Dew Point'),
          icon: (
            <IconWrapper>
              <DewPointIcon color={token.colorIcon} />
            </IconWrapper>
          ),
        },
        {
          key: DeviceType.AirTemperatureSensor,
          label: t('Air Temp'),
          icon: (
            <IconWrapper>
              <AirTemperatureIcon fillColor={token.colorIcon} innerColor="transparent" />
            </IconWrapper>
          ),
        },
        {
          key: DeviceType.FlowAndPressureSensor,
          label: t('Flow & Pressure'),
          icon: (
            <CombinationIconWrapper
              icon1={<FlowIcon color={token.colorIcon} />}
              icon2={<PressureIcon fillColor={token.colorIcon} />}
            />
          ),
        },
        {
          key: DeviceType.DewpointAndPressureSensor,
          label: t('Dew Point & Pressure'),
          icon: (
            <CombinationIconWrapper
              icon1={<DewPointIcon color={token.colorIcon} />}
              icon2={<PressureIcon fillColor={token.colorIcon} />}
            />
          ),
        },
      ],
    },
    {
      key: 'valve',
      label: t('Valve'),
      children: [
        {
          key: DeviceType.SpillValve,
          label: t('Spill Valve'),
          icon: (
            <ValveWidget
              borderColor={token.colorIcon}
              backgroundColor="transparent"
              arrowsColor={token.colorIcon}
              width={16}
              height={16}
            />
          ),
        },
      ],
    },
    filterMenu,
    connectorMenu,
  ];
};
